import React from 'react';
import styled from 'styled-components/macro';
import Button from 'components/atoms/Button';
import Grid from 'components/atoms/Grid';
import GridCol from 'components/atoms/GridCol';
import { format } from 'date-fns';

const ConfigModalContent = styled.div`
  max-height: 600px;
  overflow-y: auto;
  padding: 20px;
`;

const ConfigSection = styled.div`
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background-color: #f8f9fa;
`;

const ConfigLabel = styled.div`
  font-weight: 600;
  margin-bottom: 5px;
  color: #495057;
  font-size: 14px;
`;

const ConfigValue = styled.div`
  font-size: 13px;
  color: #6c757d;
  word-break: break-all;
  background: white;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
`;

const BooleanValue = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: white;
  background-color: ${props => (props.value ? '#28a745' : '#dc3545')};
`;

const SectionTitle = styled.h3`
  color: #495057;
  font-size: 16px;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 2px solid #007bff;
`;

export default function ConfigurationModal({ config, onClose }) {
  const formatValue = value => {
    if (typeof value === 'boolean') {
      return <BooleanValue value={value}>{value ? 'True' : 'False'}</BooleanValue>;
    }
    if (value === null || value === undefined || value === '') {
      return <span style={{ color: '#6c757d', fontStyle: 'italic' }}>Not set</span>;
    }
    if (typeof value === 'string' && value.includes('password')) {
      return '••••••••••••';
    }
    return value.toString();
  };

  const renderConfigField = (label, value) => (
    <GridCol xs={12} md={6} lg={6} key={label}>
      <ConfigLabel>{label}</ConfigLabel>
      <ConfigValue>{formatValue(value)}</ConfigValue>
    </GridCol>
  );

  const configFields = [
    { label: 'Local Testing', value: config?.LOCAL_TESTING },
    { label: 'Production', value: config?.PRODUCTION },
    { label: 'Should Debug', value: config?.SHOULD_DEBUG },
    { label: 'Should Write Logs', value: config?.SHOULD_WRITE_LOGS },
    { label: 'URL', value: config?.URL },
    { label: 'Base URL', value: config?.BASE_URL },
    { label: 'Base URL Transaction', value: config?.BASE_URL_TRANSACTION },
    { label: 'Socket URL', value: config?.SOCKET_URL },
    { label: 'MQTT URL', value: config?.MQTT_URL },
    { label: 'MQTT Username', value: config?.MQTT_USER_NAME },
    { label: 'MQTT Password', value: config?.MQTT_PASSWORD },
    { label: 'Receipt URL', value: config?.Receipt_URL },
    { label: 'Receipt API Key', value: config?.Receipt_ApiKey },
  ];

  return (
    <ConfigModalContent>
      <SectionTitle>Current Terminal Configuration</SectionTitle>

      <ConfigSection>
        <Grid xs={12} sm={12} lg={12} colGap={15} rowGap={15}>
          {configFields.map(field => renderConfigField(field.label, field.value))}

          {config?.lastUpdated && (
            <GridCol xs={12} md={12} lg={12}>
              <ConfigLabel>Last Updated</ConfigLabel>
              <ConfigValue>
                {config.lastUpdated ? format(new Date(config.lastUpdated), 'yyyy-MM-dd HH:mm:ss') : 'Never'}
              </ConfigValue>
            </GridCol>
          )}

          <GridCol xs={12} md={6} lg={6}>
            <ConfigLabel>Initialized</ConfigLabel>
            <ConfigValue>{formatValue(config?.isInitialized)}</ConfigValue>
          </GridCol>

          <GridCol xs={12} md={6} lg={6}>
            <ConfigLabel>Serial Number</ConfigLabel>
            <ConfigValue>{config?.serial_number || 'Not available'}</ConfigValue>
          </GridCol>
        </Grid>
      </ConfigSection>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
        <Button type="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </ConfigModalContent>
  );
}
